import React from 'react';

export const DisplayWidgetContext = React.createContext(null);

export const useDisplayWidgetContext = () => {
  const context = React.useContext(DisplayWidgetContext);
  if (!context) throw new Error("useDisplayWidgetContext can not be used outside it's provider");
  return context;
};
